import { GetApp } from "../../App"
import { Block, BlockField, BlockRow } from "../../Components/Block"
import { GetNMEAConfigurationContext } from "./Context"

export function NMEAConfigurationNativeView() {
  const app = GetApp()!;
  const t = app.getT("NMEAConfigurationView");
  const { nativePressureChecked, setNativePressure } = GetNMEAConfigurationContext();

  return (
    <Block key="native">
      <BlockRow className="block-row-checkboxes checkbox-text-bigger">
        <BlockField label={t("condition_native_pressure")} labelAfter={true} labelFor="nativePressureEnabled">
          <input id="nativePressureEnabled" type="checkbox" name="thresholds.nativePressureEnabled" defaultValue="" onChange={() => { setNativePressure(!nativePressureChecked); }} checked={nativePressureChecked} />
        </BlockField>
      </BlockRow>
    </Block>
  );
}
